import styled from '@emotion/styled'

export const BankReconciliationAccountSelectAddAccountWrapper = styled.div``
